import { Component } from 'preact';
import PropTypes from 'prop-types';
import CustomSelect from '../../../CustomSelect';
import { FormButtons } from '../../components/FormButtons';

const TIME_OPTIONS = [
  { value: 'manha-9h-as-12h', label: 'Manhã - 9h às 12h' },
  { value: 'tarde-14h-as-16h', label: 'Tarde - 14h às 16h' },
  {
    value: 'final-de-tarde-16h-as-18h',
    label: 'Final de tarde - 16h às 18h',
  },
];

export class ChooseUnitAndDate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dateOptions: this.generateDateOptions(),
    };

    this.handleUnitChange = this.handleUnitChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleTimeChange = this.handleTimeChange.bind(this);
  }

  handleUnitChange(unitSlug, unitName) {
    const { setTestDriveData } = this.props;
    setTestDriveData({ unitSlug, unitName });
  }

  handleDateChange(date) {
    const { setTestDriveData } = this.props;
    setTestDriveData({ preferredDate: date });
  }

  handleTimeChange(preferredTime) {
    if (!preferredTime) return;

    const preferredTimeLabel = TIME_OPTIONS.find(
      option => option.value === preferredTime,
    ).label;

    const { setTestDriveData } = this.props;
    setTestDriveData({ preferredTime, preferredTimeLabel });
  }

  generateDateOptions() {
    const firstDate = new Date();
    firstDate.setDate(firstDate.getDate() + 2);

    const options = [];
    const current = new Date(firstDate);
    const optionsNumber = 14;

    while (options.length < optionsNumber) {
      const isSunday = current.getDay() === 0;

      if (!isSunday) {
        const dateString = current.toLocaleDateString('pt-BR');
        const weekday = current.toLocaleDateString('pt-BR', {
          weekday: 'long',
        });

        options.push({
          value: current.toISOString().split('T')[0],
          label: `${dateString} - ${weekday
            .charAt(0)
            .toUpperCase()}${weekday.slice(1)}`,
        });
      }

      current.setDate(current.getDate() + 1);
    }

    return options;
  }

  render() {
    const {
      unitSlug,
      preferredDate,
      preferredTime,
      prevStep,
      nextStep,
      unitOptions,
    } = this.props;

    const { dateOptions } = this.state;

    const isNextDisabled = !unitSlug || !preferredDate || !preferredTime;

    return (
      <form>
        <header className="titles-container">
          <h2 className="test-drive__title">Selecione uma unidade</h2>
          <p className="test-drive__subtitle">
            Escolha a unidade mais próxima de você.
          </p>
        </header>

        <section className="unit-list">
          {unitOptions.map(unit => (
            <label
              key={unit.id}
              className={`unit-option ${
                unit.slug === unitSlug ? 'unit-option--selected' : ''
              }`}
            >
              <input
                type="radio"
                name="unit"
                value={unit.slug}
                checked={unit.slug === unitSlug}
                onChange={() => this.handleUnitChange(unit.slug, unit.name)}
                className="unit-option__radio"
              />
              <div className="unit-option__info">
                <span className="unit-option__name">
                  <i className="icon icon-map" /> {unit.name}
                </span>
                <span className="unit-option__address">{unit.address}</span>
                {unit.mapUrl ? (
                  <div>
                    {' '}
                    <a
                      href={unit.mapUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="unit-option__map-link"
                    >
                      Ver mapa
                    </a>
                    <i className="icon icon-link ml-1" />
                  </div>
                ) : null}
              </div>
            </label>
          ))}
        </section>

        <section className="date-time-selects">
          <h3 className="test-drive__title">
            Selecione uma data de preferência
          </h3>
          <p className="test-drive__subtitle">
            Informe sua preferência de data e horário para realizar o test
            drive.
          </p>

          <div className="choose-vehicle-selects">
            <div className="choose-vehicle-select">
              <label className="test-drive__label">Data</label>
              <CustomSelect
                handleSelectChange={({ target }) =>
                  this.handleDateChange(target.value)
                }
                name="date"
                options={dateOptions}
                value={preferredDate}
                placeholderValue="Selecione a data"
                searchEnabled={false}
              />
            </div>

            <div className="choose-vehicle-select">
              <label className="test-drive__label">Horário</label>
              <CustomSelect
                handleSelectChange={({ target }) =>
                  this.handleTimeChange(target.value)
                }
                name="time"
                options={TIME_OPTIONS}
                value={preferredTime}
                placeholderValue="Selecione o horário"
                searchEnabled={false}
              />
            </div>
          </div>

          <p className="test-drive__text--small">
            <b>Importante:</b> data e horário estão sujeitos à confirmação
            conforme disponibilidade da unidade.
          </p>
        </section>

        <FormButtons
          prevStep={prevStep}
          nextStep={nextStep}
          nextButtonDisabled={isNextDisabled}
        />
      </form>
    );
  }
}

ChooseUnitAndDate.propTypes = {
  setTestDriveData: PropTypes.func,
  prevStep: PropTypes.func,
  nextStep: PropTypes.func,
  unitSlug: PropTypes.string,
  preferredDate: PropTypes.string,
  preferredTime: PropTypes.string,
  unitOptions: PropTypes.arrayOf({}),
};
